module.exports = __webpack_public_path__ + "static/media/Homepage.445661a1.png";